import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import { translate } from 'react-translate';
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';

const TableLogs = ({ data, loading, t }) => {

  const replaceMessage = (message, keys) => {
    try {
      let parsedKeys = typeof keys === 'string' ? JSON.parse(keys) : keys;
      parsedKeys = typeof parsedKeys === 'object' && parsedKeys !== null ? parsedKeys : {};
      const translated = t(message, parsedKeys);
      return typeof translated === 'string' ? translated.replace('logsDetail.', '') : message;
    } catch (e) {
      console.error('Translation error:', { message, keys, error: e });
      return message;
    }
  };

  return (
    <>
      {loading ? (
        <LoadingLocal />
      ) : (
        <div className="table-data">
          <Table id="logs" responsive hover>
            <thead>
              <tr>
                <th className="module-header">{t('module')}</th>
                <th className="message-header">{t('message')}</th>
                <th className="env-header">{t('environment')}</th>
                <th className="created-header">{t('created')}</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 &&
                data.map((p, index) => {
                  const session = typeof p.session === 'object' ? p.session : {};
                  const keys = p.keys;
                  const created = moment(p.created).format('YYYY-MM-DD HH:mm:ss');
                  const device = session?.user?.device?.user_agent || t('unknown');
                  const ip = (p.ip || t('unknown')).replace('::ffff:', '');
                  const classe = p.severity ?? p.level;
                  const username = session?.user?.username || t('unknown');
                  const auth_email = session?.user?.auth_email || t('unknown');
                  const first_name = session?.user?.firstName || t('unknown');
                  const last_name = session?.user?.lastName || t('unknown');
                  const type = session?.user?.type || t('unknown');

                  // --- INICIO DE LA MODIFICACIÓN ---
                  // 1. Obtenemos ambos mensajes
                  const translatedMessage = replaceMessage(p.message, keys);
                  const englishMessage = p.message_rendered;
                  // --- FIN DE LA MODIFICACIÓN ---

                  return (
                    <tr key={index} className={classe}>
                      <td className="module-cell">
                        {p.module || t('none')}
                      </td>
                      <td id={`message-${index}`} className="message-cell">
                        {p.user !== '000000000000000000000000' && (
                          <>
                            <span>
                              <b>{t(type)}:</b> {first_name}, {last_name}
                            </span>
                            <br />
                            <span>
                              <b>{t('username')}:</b> {username}
                            </span>
                            <br />
                            <span>
                              <b>{t('mail')}:</b>{' '}
                              <a href={`mailto:${auth_email}`}>{auth_email}</a>
                            </span>
                            <br />
                            <br />
                          </>
                        )}
                        
                        {/* --- INICIO DE LA MODIFICACIÓN --- */}
                        {/* 2. Renderizamos el mensaje traducido (principal) */}
                        <span>{translatedMessage}</span>
                        
                        {/* 3. Renderizamos el mensaje en inglés si existe y es diferente */}
                        {englishMessage && englishMessage !== translatedMessage && (
                          <span style={{
                            display: 'block',
                            marginTop: '5px',
                            color: '#6c757d', // Color secundario (gris)
                            fontSize: '0.875em', // Un poco más pequeño
                            fontStyle: 'italic'
                          }}>
                            {englishMessage}
                          </span>
                        )}
                        {/* --- FIN DE LA MODIFICACIÓN --- */}
                        
                      </td>
                      <td id={`env-${index}`} className="env-cell">
                        <span>
                          <b>{t('referer')}:</b> {p.referer}
                        </span>
                        <br />
                        <span style={{ whiteSpace: 'pre-line' }}>
                          <b>{t('device')}:</b> {device}
                        </span>
                        <br />
                        <span>
                          <b>{t('ip')}:</b> {ip}
                        </span>
                      </td>
                      <td className="created-cell">{created}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      )}
    </>
  );
};

TableLogs.defaultProps = {
  data: [],
  loading: true
};

TableLogs.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool
};

export default translate('logsDetail')(TableLogs);
